import { Component, EventEmitter, Input, Output } from '@angular/core'
import { reviewDetailsModel, reviewsModel } from '../../models/reviews.models'
import { TranslateService } from '@ngx-translate/core'
import { ReviewStatusEnum } from '../../models/reviews.enum'
import { SharedService } from 'src/app/shared/services/shared.service'
import { MatDialog } from '@angular/material/dialog'
import { ReviewDetailsComponent } from '../review-details/review-details.component'
import { ReviewsService } from '../../services/reviews.service'

@Component({
	selector: 'app-reviews-table',
	templateUrl: './reviews-table.component.html',
	styleUrl: './reviews-table.component.scss',
})
export class ReviewsTableComponent {
	@Input() reviews: reviewsModel[] = []
	@Input() reviewFilter = {
		paging: {
			pageNumber: 1,
			pageSize: 10,
		},
		activeTab: 1,
		countryId: 224,
	}
	@Input() totalCount: number = 0
	@Input() countryId: number = 0
	@Output() changeStatus = new EventEmitter()
	Math = Math
	ReviewStatusEnum = this.SharedService.returnEnumArray(ReviewStatusEnum)
	constructor(
		public translate: TranslateService,
		private SharedService: SharedService,
		private dialog: MatDialog,
		private ReviewsService: ReviewsService
	) {}
	changeReviewStatus(reviewId: number = 0, status: number) {
		let body = {
			reviewId,
			status,
			countryId: this.countryId,
		}
		this.changeStatus.emit(body)
	}
	getReviewDetails(id: number) {
		this.ReviewsService.getReviewDetails(id).subscribe({
			next: (res: reviewDetailsModel) => {
				res.id = id
				this.openDialog(res)
			},
		})
	}
	openDialog(data: reviewsModel) {
		data.countryId = this.countryId
		this.dialog
			.open(ReviewDetailsComponent, {
				width: '752px',
				data,
			})
			.afterClosed()
			.subscribe((res) => this.changeReviewStatus(res.reviewId, res.status))
	}
}
